module.exports = __webpack_public_path__ + "img/icon_timesheet.5d98cba9.png";